<div class="content-container">
    <h3 mat-dialog-title>{{dialogTitle}}</h3>
    <mat-dialog-content>{{dialogText}}</mat-dialog-content>
</div>
<mat-dialog-actions>
    <button mat-flat-button id="no-button" [mat-dialog-close]="false">No</button>
    <button mat-flat-button id="yes-button" [mat-dialog-close]="true">Yes</button>
</mat-dialog-actions>